// extracted by mini-css-extract-plugin
module.exports = {"Root":"DragHandle_Root__2Ntlp","Vertical":"DragHandle_Vertical__3zJiT","Horizontal":"DragHandle_Horizontal__2p_w8","RelativeWrapper":"DragHandle_RelativeWrapper__BtsD4"};